/**
 * Questo componente non fa altro che creare un Event Bus globale nell'applicazione in modo che anche componenti completamente
 * disaccoppiati possano scambiarsi informazioni mediante eventi.
 * Ad esempio, WorldHeadbar permette di scrivere messaggi all'interno della searchBar mediante un evento.
 * 
 * Il bus viene aggiunto all'applicazione Vue come parte integrante del plugin 'anm22Plugin'.
 */

import Vue from 'vue'

export const EventBus = new Vue();